import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_INQ010_Request,
  IAPI_INQ010_Response,
} from "../../../type/apiType";

/**
 * 掛金対象法人・職員情報照会参照API
 * @return httpAPI_INQ010
 */
const httpAPI_INQ010 = async (
  param: IAPI_INQ010_Request
): Promise<IAPI_INQ010_Response> => {
  let res = await http.post(ApiUrl.API_INQ010, {
    ...param,
  });

  return res.data;
};

export { httpAPI_INQ010 };
